var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.cssClasses,style:(_vm.style)},[_c('svg',{attrs:{"x":"0","y":"0","width":"32","height":"44","viewBox":"0 0 38 52"}},[_c('path',{attrs:{"d":"M 13 47 v -20 h -10 l 16 -24 l 16 24 h -10 v 20 z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }